const forms = document.querySelectorAll(".order-form");

let priceSummary = {};
let totalSum = 0;
let totalTax = 0;

//Calculate total price for the product
function calculatePrice(product) {
  const singlePrice = parseFloat(
    product.querySelector("[data-price]").getAttribute("data-price")
  );
  const quantity = product.querySelector(".product-item__quantity").value;
  return singlePrice * quantity;
}

forms.forEach((form) => {
  const productItems = form.querySelectorAll(".product-item");
  const DOMtotalPrice = form.querySelector(".total-price");
  const DOMtotalTax = form.querySelector(".total-tax");

  //Function on each product item
  productItems.forEach((product) => {
    const productId = product.getAttribute("data-product-id");
    priceSummary[productId] = 0; //Init product in price array

    //Event listener for "change" on every input
    product.querySelector("input").addEventListener("change", () => {
      //Set new calculated price to list
      priceSummary[productId] = calculatePrice(product);
      //Update gobal total price
      totalSum = 0; //Reset total sum
      totalTax = 0; //Reset total tax
      for (const [key, value] of Object.entries(priceSummary)) {
        totalSum = totalSum + value;
      }
      DOMtotalPrice.innerText = `${new Intl.NumberFormat("de-DE", {
        style: "currency",
        currency: "EUR",
      }).format(totalSum)}`;
      //Update tax
      // totalTax = totalSum / 1.19;
      // totalTax = totalSum - totalTax;
      // DOMtotalTax.innerText = `${new Intl.NumberFormat("de-DE", {
      //   style: "currency",
      //   currency: "EUR",
      // }).format(totalTax)}`;
    });
  });
});
